/**
 * The item rewards one hero receives for a quest: the shared `rewards.items`
 * plus the entry of `rewardClassItems` for the hero's class (lane AO,
 * 2026-10-08). Server grant, turn-in fit, and every client reward list read
 * through here so they always agree on what a class gets.
 */

import type { InventoryItem } from '../CharacterTypes';
import type { QuestDefinition } from '../content/generated/quests.gen';

export type QuestRewardItemsShape = Pick<QuestDefinition, 'rewards'> & Partial<Pick<QuestDefinition, 'rewardClassItems'>>;

export function questRewardItemsFor(quest: QuestRewardItemsShape, heroClass?: string | null): InventoryItem[] {
  const shared = quest.rewards.items ?? [];
  const classItem = heroClass ? quest.rewardClassItems?.[heroClass.toLowerCase()] : undefined;
  return classItem ? [...shared, classItem] : [...shared];
}

/** The quest's rewards object as this hero receives it (wire payloads, reward lists). */
export function questRewardsFor<T extends QuestRewardItemsShape>(quest: T, heroClass?: string | null): T['rewards'] {
  const items = questRewardItemsFor(quest, heroClass);
  return items.length ? { ...quest.rewards, items } : { ...quest.rewards };
}
